<template>
  <div>
    <v-file-input
      v-model="files"
      :label="label"
      multiple
      :rules="validationRules"
      :hint="hint"
      persistent-hint
      outlined
      clearable
      show-size
      color="brandCyan"
      prepend-icon
      data-testid="file-input"
    >
      <template v-slot:selection="{ index, text }">
        <v-chip close @click:close="removeFile(index)">
          {{ text }}
        </v-chip>
      </template>
    </v-file-input>
  </div>
</template>

<script>
export default {
  name: "FileInput",
  props: {
    value: {
      type: [File, Array],
      default: null,
    },
    label: {
      type: String,
      default: "Upload a file or photo",
    },
    showFileSizeWarning: {
      type: Boolean,
      default: true,
    },
    maxFileSizeMB: {
      type: Number,
      default: 50,
    },
    maxFiles: {
      type: Number,
      default: 5,
      validator: function (value) {
        return typeof value === "number" && value > 0;
      },
    },
  },
  computed: {
    files: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    isValid() {
      return !this.fileTooLarge && !this.tooManyFiles && !this.noFiles;
    },
    fileTooLarge() {
      if (!this.files) return false;
      return this.files.some((f) => f?.size > this.maxFileSizeMB * 1024 * 1024);
    },
    tooManyFiles() {
      if (!this.files) return false;
      return this.files.length > this.maxFiles;
    },
    noFiles() {
      if (!this.files) return true;
      return this.files.length === 0;
    },
    validationRules() {
      const rules = [
        () => !this.fileTooLarge || `File size must be less than ${this.maxFileSizeMB} MB`,
        () => !this.tooManyFiles || `Maximum ${this.maxFiles} files allowed`,
      ];
      return rules;
    },
  },
  data() {
    return {
      hint: `A max file size of ${this.maxFileSizeMB} MB is supported. ${
        this.maxFiles === 1 ? "Upload a file." : `Upload up to ${this.maxFiles} files.`
      }`,
    };
  },
  methods: {
    removeFile(index) {
      this.files = this.files.filter((_, i) => i !== index);
    },
  },
  watch: {
    isValid: {
      handler(newVal) {
        this.$emit("isValid", newVal);
      },
      immediate: true, // This fires immediately and on changes
    },
  },
};
</script>

<style scoped></style>
